"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.curry = curry;
exports.isString = isString;
exports.isObject = isObject;
exports.capitalize = capitalize;
exports.hasProp = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function curry(fn) {
  var _this = this;

  var createRecurser = function createRecurser(acc, count) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return args.length > 0 ? recurse(_toConsumableArray(acc).concat(args), count) : recurse(_toConsumableArray(acc).concat([null]), count);
    };
  };

  var recurse = function recurse(acc, count) {
    return acc.length < count ? createRecurser(acc, count) : fn.apply(_this, acc);
  };

  return createRecurser([], fn.length);
}

var hasProp = curry(function (obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
});
exports.hasProp = hasProp;

function isString(val) {
  return typeof val === 'string' || val instanceof String;
}

function isObject(value) {
  return value && _typeof(value) === 'object' && value.constructor === Object;
}

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}